import { axiosInstance } from "./BaseService" 

const PURCHASE_URL = '/purchase';

// purchase recommendation
export const fetchPurchaseRecommendationData = async (storeId) => {
  try {
    const purchaseRecommendationUrl = `${PURCHASE_URL}/recommendations?storeId=${storeId}`;

    const response = await axiosInstance.get(purchaseRecommendationUrl);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const fetchAvailableItens = async (storeId, supplierId) => {
  try {
    const purchaseRecommendationUrl = `${PURCHASE_URL}/recommendations/available-itens/${storeId}/${supplierId}`;

    const response = await axiosInstance.get(purchaseRecommendationUrl);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const patchPurchaseRecommendationData = async (inputs, storeId) => {

  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  
  const formattedDate = `${year}-${month}-${day}`;

  let updatedInputs = {};

  for (const key in inputs) {
    if (inputs.hasOwnProperty(key)) {
      const { suppliers, ...rest } = inputs[key];

      if (Object.keys(rest).length === 0) continue;

      updatedInputs[key] = {
          ...rest,
          purchaseDate: formattedDate
      };
    }
  }

  if (Object.keys(updatedInputs).length === 0) return;

  try {
    const purchaseRecommendationUrl = `${PURCHASE_URL}/recommendations?storeId=${storeId}`;
    const response = await axiosInstance.patch(purchaseRecommendationUrl, updatedInputs);
    updatedInputs = {};
    
    return response.data;
  } catch(err) {
      updatedInputs = {};
      throw err;
  } finally {
    updatedInputs = {};
    inputs = {}
  }
};

// orders
export const createOrder = async (payload) => {

  try {
    const ordersUrl = `${PURCHASE_URL}/orders`;
    const response = await axiosInstance.post(ordersUrl, payload);
    return response.data;
  } catch(err) {
    throw err;
  }
};

export const fetchOrders = async (storeId) => {

  try {
    const ordersUrl = `${PURCHASE_URL}/orders?storeId=${storeId}`;
    const response = await axiosInstance.get(ordersUrl);
    return response.data;
  } catch(err) {
    throw err;
  }
};

export const fetchOrdersItems = async (orderId, storeId) => {

  try {
    const ordersUrl = `${PURCHASE_URL}/orders/${orderId}/${storeId}`;
    const response = await axiosInstance.get(ordersUrl);
    return response.data;
  } catch(err) {
    throw err;
  }
};

export const patchOrders = async (payload) => {

  try {
    const ordersUrl = `${PURCHASE_URL}/orders`;
    const response = await axiosInstance.patch(ordersUrl, { payload });
    return response.data;
  } catch(err) {
    throw err;
  }
};

// prefix
export const fetchPrefixes = async () => {
  try {
    const response = await axiosInstance.get(`${PURCHASE_URL}/prefix`);
    return response.data;
  } catch (err) {
    console.error('Erro ao buscar dados da loja');
    throw err;
  }
};

export const patchPrefixes = async (inputs, hasToRemovePrefix = false) => {
  try {

    const payload = {};
    if (hasToRemovePrefix) {
      Object.values(inputs).forEach((item) => {
        const { prefixId, isPrefixAvailable } = item;

        const prefixIds = Array.isArray(prefixId) ? prefixId : [prefixId];

        prefixIds.forEach((id) => {
          payload[id] = { prefixId: id, isPrefixAvailable };
        });
      });
    } else {
      Object.values(inputs).forEach((item) => {
        const { prefixId, isPrefixAvailable } = item;
        if (prefixId !== undefined) {
          payload[prefixId] = { prefixId, isPrefixAvailable };
        }
      });
    };

    const response = await axiosInstance.patch(`${PURCHASE_URL}/prefix`, { inputs: payload });

    return response.data;
  } catch (err) {
    throw err;
  }
};

export const createPrefixes = async (inputs) => {
  try {

    const payload = Array.isArray(inputs)
    ? inputs.map(({ prefixName, prefixDescription }) => ({
        prefixName: prefixName?.trim(),
        prefixDescription: prefixDescription?.trim(),
      }))
    : {
        prefixName: inputs.prefixName?.trim(),
        prefixDescription: inputs.prefixDescription?.trim(),
      };

    const response = await axiosInstance.post(`${PURCHASE_URL}/prefix`, payload);

    return response.data;
  } catch (err) {
    console.error("Erro ao criar prefixos:", err);
    throw err;
  }
};